/**
 * TanStack Query hooks for `hubspot-integration`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	hubspotIntegrationQueryKeys,
	type CreateHubspotIntegrationBody,
	type ListHubspotIntegrationResponse,
	type HubspotIntegrationRow,
} from "./api";

export function useHubspotIntegrationList(): UseQueryResult<ListHubspotIntegrationResponse, Error> {
	return useQuery({
		queryKey: hubspotIntegrationQueryKeys.list(),
		queryFn: list,
	});
}

export function useHubspotIntegrationCreate(): UseMutationResult<HubspotIntegrationRow, Error, CreateHubspotIntegrationBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: hubspotIntegrationQueryKeys.all });
		},
	});
}

export function useHubspotIntegrationDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: hubspotIntegrationQueryKeys.all });
		},
	});
}
